import dayjs, { Dayjs } from "dayjs";
import { useEffect, useState } from "react";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";

interface AvailabilityCalendarHook {
	firstMonth: Dayjs;
	secondMonth: Dayjs;
	nextMonth: Function;
	prevMonth: Function | Boolean;
	occupanciesList: String[];
}

export const useAvailabilityCalendar = ({ occupancies }): AvailabilityCalendarHook => {
	dayjs.locale("es");
	dayjs.extend(isSameOrBefore);
	const [firstMonth, setFirstMonth] = useState(dayjs());
	const [secondMonth, setSecondMonth] = useState(dayjs().add(1, "month"));
	const [occupanciesList, setOccupanciesList] = useState<String[]>(occupancies);

	const nextMonth = () => {
		setFirstMonth(firstMonth.add(1, "month"));
		setSecondMonth(secondMonth.add(1, "month"));
	};

	const prevMonth = () => {
		setFirstMonth(firstMonth.subtract(1, "month"));
		setSecondMonth(secondMonth.subtract(1, "month"));
	};

	useEffect(() => {
		if (occupancies) {
			let totalOccupancies = [];
			occupancies.forEach(occupancie => {
				let begin = dayjs(occupancie.date_begin);
				let end = dayjs(occupancie.date_end);
				while (begin.isSameOrBefore(end, "day")) {
					totalOccupancies.push(begin.format("YYYY-MM-DD"));
					begin = begin.add(1, "day");
				}
			});
			setOccupanciesList(totalOccupancies);
		}
	}, [occupancies]);

	return {
		firstMonth,
		secondMonth,
		nextMonth,
		prevMonth: firstMonth.isAfter(dayjs(), "month") ? prevMonth : false,
		occupanciesList,
	};
};
